import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import SecondHeader from "../Header/SecondHeader";
import IRHistoryHead from "./Parts/IRHistoryHead";
import IRHistoryWidgets from "./Parts/IRHistoryWidgets";
import IRHistoryTable from "./Parts/IRHistoryTable";
import trans from "../../utils";
import { useContext } from "react";
import { filtrationcontext } from "../../context/Filtercontext";

const IRHistory = () => {
  const { limit, searchQuery } = useContext(filtrationcontext);
  const [filters, setFilters] = useState({
    type: null,
    project: null,
    discipline: null,
    requestStatus: null,
    startDate: null,
    endDate: null,
    search: null,
  });
  const [isShown, setIsShown] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [widgetData, setWidgetData] = useState({
    totalReviewed: 0,
    approvedThisPeriod: 0,
    rejectedThisPeriod: 0,
    averageReviewTime: 0,
  });

  const isFirstRender = useRef(true);

  // Call API on mount without date requirement
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filters]);

  const handleFetchData = () => {
    setIsShown(true);
    setCurrentPage(1);
  };

  const handleDataChange = (newWidgetData) => {
    setWidgetData(newWidgetData);
  };

  return (
    <>
      <Helmet>
        <title>{trans("IR History")}</title>
      </Helmet>
      <SecondHeader title={trans("IR History")} type="reports" />
      <IRHistoryHead
        filters={filters}
        setFilters={setFilters}
        onSubmit={handleFetchData}
      />
      <div className="report-view">
        <div className="report-sheets">
          <IRHistoryWidgets data={widgetData} />
          <IRHistoryTable
            filters={filters}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isShown={isShown}
            onDataChange={handleDataChange}
          />
        </div>
      </div>
    </>
  );
};

export default IRHistory;
